import { MessageBox } from 'element-ui';

function confirm (
  content,
  title = '提示',
  settings = {},
) {
  let messageSetting = {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
    ...settings
  }
  let { distinguishCancelAndClose } = settings
  return MessageBox.confirm(content, title, messageSetting).then((action) => {
    if (distinguishCancelAndClose) return action
    return true;
  }).catch((action) => {
    if (distinguishCancelAndClose) return action
    return false
  });
}


export default confirm
